module.exports = __webpack_public_path__ + "4a793aa44240fd8cd0ec473400872cda.png";